import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as accountsApi from '@/network/api/accounts.api.js'

/** requests Cards List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_cardsgetCards
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
	const res = await cardsApi.cards(payload)

	if (res) context.commit('SAVE_CARDS_LIST', res.data.data)
	return res
}

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
@return {promise} - Accounts Balances
*/
export const requestAccountsBalances = async (context, payload) => {
	const res = await accountsApi.requestAccountsBalances(payload)

	if (res) context.commit('SAVE_ACCOUNTS_BALANCES', res.data.data)
	return res
}

/** Anticipate Payment
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_cardsanticipateCreditPayment
@return {promise}
*/
export const anticipatePayment = async (context, payload) => {
	const res = await cardsApi.anticipateCreditPayment(payload)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
	context.commit('CLEAR_FEATURE_STATE')
}
